import { BQ_CLICKED_HOMEPAGE_LO_SEARCH_TAG } from '../../../utils/biEvents/events/bigQueryEvents';
import {
    CLICKED_POPULAR_SEARCH_TAG,
    CLICKED_BANNER_SEARCH
} from '../../../utils/biEvents/events/mixPanelEvents';
import { sendBigQueryEvent, sendMixPanelEvent } from '../../../utils/biEvents';

export const BI_TYPE_TAGS = 'bi_tags';
export const BI_TYPE_SEARCH = 'bi_search';

const reportTagBi = (data) => {
    const mpParams = { name: data.name, order: data.position };
    const bqParams = {
        position: data.position,
        page: {
            element: {
                type: data.type,
                text: data.name
            }
        },
        category: {
            id: data.categoryId,
            name: data.categorySlug
        },
        sub_category: {
            id: data.subCategoryId,
            name: data.subCategorySlug
        }
    };

    sendMixPanelEvent({ eventName: CLICKED_POPULAR_SEARCH_TAG, params: mpParams });
    sendBigQueryEvent({ eventName: BQ_CLICKED_HOMEPAGE_LO_SEARCH_TAG, params: bqParams });
};

const reportSearchBi = (data) => {
    sendMixPanelEvent({ eventName: CLICKED_BANNER_SEARCH, params: data });
};

export const reportBi = (type, data) => {
    switch (type) {
        case BI_TYPE_TAGS:
            reportTagBi(data);
            break;
        case BI_TYPE_SEARCH:
            reportSearchBi(data);
            break;
        default:
            break;
    }
};

export const POPULAR_SEARCH_NAMES = {
    LOGO_DESIGN: 'logo_design',
    WEB_AND_MOBILE_DESIGN: 'web_and_mobile_design',
    WORDPRESS: 'wordpress',
    DROPSHIPPING: 'dropshipping',
    NFT_ART: 'nft_art'
};

export const POPULAR_SEARCH_TYPES = {
    SUBCATEGORY: 'subcategory',
    STORE: 'store',
    SEARCH: 'search'
};

const logoDesign = {
    name: POPULAR_SEARCH_NAMES.LOGO_DESIGN,
    type: POPULAR_SEARCH_TYPES.SUBCATEGORY,
    categoryId: 3,
    categorySlug: 'graphics-design',
    subCategoryId: 49,
    subCategorySlug: 'creative-logo-design'
};

const webMobileDesign = {
    name: POPULAR_SEARCH_NAMES.WEB_AND_MOBILE_DESIGN,
    type: POPULAR_SEARCH_TYPES.SUBCATEGORY,
    categoryId: 3,
    categorySlug: 'graphics-design',
    subCategoryId: 151,
    subCategorySlug: 'web-plus-mobile-design'
};

const wordpress = {
    name: POPULAR_SEARCH_NAMES.WORDPRESS,
    type: POPULAR_SEARCH_TYPES.SUBCATEGORY,
    categoryId: 10,
    categorySlug: 'programming-tech',
    subCategoryId: 91,
    subCategorySlug: 'wordpress-services'
};

const dropshipping = {
    name: POPULAR_SEARCH_NAMES.DROPSHIPPING,
    type: POPULAR_SEARCH_TYPES.STORE,
    storeSlug: 'dropshipping'
};

const nftArt = {
    name: POPULAR_SEARCH_NAMES.NFT_ART,
    type: POPULAR_SEARCH_TYPES.SEARCH,
    term: 'NFT Art'
};

export const popularSearches = [
    webMobileDesign,
    wordpress,
    logoDesign,
    dropshipping,
    nftArt
];
